<div class="row">
    <div class="col-md-3">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <p><span>Onboarded Reseller</span><span class="dash_icon_img"><span
                            class="material-symbols-outlined d1 success">check_circle</span></span></p>
                <h4 class="my-0">{{onboardedReseller}}
                </h4>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <p><span>Active Reseller</span><span class="dash_icon_img"><span
                            class="material-symbols-outlined d1 success">check_circle</span></span></p>
                <h4 class="my-0">{{activeReseller}}
                </h4>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <p><span>Blocked Reseller</span><span class="dash_icon_img"><span
                            class="material-symbols-outlined d1 danger">block</span></span></p>
                <h4 class="my-0">{{blockedReseller}}
                </h4>
            </div>
        </div>
    </div>
    <!-- <div class="col-md-3">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <p><span>Registered Customers</span><span class="dash_icon_img"><span
                            class="material-symbols-outlined d1 success">check_circle</span></span></p>
                <h4 class="my-0">{{totalCustomers}}
                </h4>
            </div>
        </div>
    </div> -->
</div>
<div class="row">
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 mt-2">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <h5>Top 5 Performing Reseller</h5>
                <p>Ranking according to date range selected</p>
            </div>
            <div class="dashboard_block_body">
                <div class="no-data-wrapper d-flex" *ngIf="graphdataReseller.length == 0">
                    <div class="w-100 p-2 text-center border-top no-data-div">No Data available</div>
                </div>
                <ng-container *ngIf="graphdataReseller.length > 0">
                    <app-table-view [visibleColumnData]="visibleColumnDataReseller"
                        [visibleColumnsId]="visibleColumnsIdReseller" [graphdata]="graphdataReseller"
                        [graphHeader]="graphHeaderReseller" title="" tableBackground="var(--grey3)" buttonTitle=""
                        [showIconButtonEnd]="false" [showPaginator]="false" [canCreate]="false" [canView]="false"
                        [canDelete]="false" [canEdit]="false" [showFilters]="false" [showPaginator]="false"
                        className="rounded-top-0"></app-table-view>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 mt-2">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <h5>Recently Added Reseller</h5>
                <p>Data according date range selected</p>
            </div>
            <div class="dashboard_block_body">
                <div class="no-data-wrapper" [ngClass]="{'d-flex':topRecentReseller.length == 0}">
                    <div class="w-100 p-2 text-center border-top no-data-div" *ngIf="topRecentReseller.length == 0">No
                        Data available</div>
                    <table class="table mb-0" *ngIf="topRecentReseller.length > 0">
                        <tbody>
                            <tr *ngFor="let item of topRecentReseller">
                                <td class="py-1 align-middle text-center w-50px"><img [src]="item.imgUrl"
                                        class="h-50px" /></td>
                                <td class="text-grey2 py-1 align-middle">{{item.name}}<span
                                        class="text-grey3 d-block">ID: {{item.id}}</span></td>
                                <td class="text-right py-1 align-middle text-center w-32px"><a
                                        [href]="item.navigationUrl"><img
                                            src="../../../../assets/images/dashboard_icons/chevron_right.png" /></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>